import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
/**
* @public
*/
const ChevronRightIcon = /* @__PURE__ */ forwardRef(function(props, ref) {
	return /* @__PURE__ */ jsx("svg", {
		"data-sanity-icon": "chevron-right",
		width: "1em",
		height: "1em",
		viewBox: "0 0 25 25",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		ref,
		children: /* @__PURE__ */ jsx("path", {
			d: "M10 8L14.5 12.5L10 17",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinejoin: "round"
		})
	});
});
export { ChevronRightIcon, ChevronRightIcon as default };

//# sourceMappingURL=ChevronRight.js.map